import React from 'react';
import PropTypes from 'prop-types';

const ImageDetails = ({ caption, credits, shouldDisplayCaption, shouldDisplayCredits }) => (
  <div className="image__details" data-testid="image-details">
    {shouldDisplayCaption && <div className="caption">{caption}</div>}
    {shouldDisplayCredits && <div className="credits">{credits}</div>}
  </div>
);

ImageDetails.propTypes = {
  caption: PropTypes.string,
  credits: PropTypes.string,
  shouldDisplayCaption: PropTypes.bool.isRequired,
  shouldDisplayCredits: PropTypes.bool.isRequired
};

ImageDetails.defaultProps = {
  caption: null,
  credits: null
};

export default ImageDetails;
